<script>
import axios from 'axios'
export default {
  data: function () {
    return {
      connections: [],
      client: {},
      clientUrl: '/api/client/'
    };
  },
  methods: {
    fetchClient: function () {
      let self = this;
      axios.get(`${this.clientUrl}${this.id}`).then(function (response) {
        self.client = response.data.result;
        self.fetchConnections();
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchConnections: function () {
      let self = this;
      axios.get(`${this.clientUrl}${this.id}/connections`).then(function (response) {
        self.connections = response.data.result;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.fetchClient();
      this.interval = setInterval(this.fetchClient.bind(this), 3000);
    });
  },
  name: "Client",
  props: ['id']
};
</script>
<template>
  <div>
    <table class="striped">
      <thead>
        <tr>
          <th>ID</th>
          <th>IP</th>
          <th>Service Level</th>
          <th>INI Version</th>
          <th>Test Link Count</th>
          <th>Ping Count</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ client.id }}</td>
          <td>{{ client.ip }}</td>
          <td>{{ client.service_level }}</td>
          <td>{{ client.ini_version }}</td>
          <td>{{ client.test_link_count }}</td>
          <td>{{ client.total_pings }}</td>
        </tr>
      </tbody>
    </table>

    <h5>Connections</h5>
    <table class="striped">
      <thead>
        <tr>
          <th>Server</th>
          <th>Port</th>
          <th>Name</th>
          <th>Sub-Protocol</th>
          <th>State</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="connection in connections" v-bind:key="connection.uuid">
          <template v-if="connection.channel_id === null">
            <td><router-link v-bind:to="$route.fullPath + '/' + connection.server_id">
                {{ connection.server_id }}
            </router-link></td>
            <td>{{ connection.port }}</td>
            <td>{{ connection.name }}</td>
            <td>{{ connection.subprotocol }}</td>
            <td>{{ connection.state }}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>
